import isMobilePhone from 'validator/lib/isMobilePhone';

export default function validatePhoneNumber(value: string): string | true {
  const v = value?.trim().replace(/\D/g, '');

  if (!v) {
    return '번호를 입력해주세요.';
  }

  if (v.length < 8) {
    return '8자리 번호를 입력해주세요.';
  }

  if (!isMobilePhone(`010${v}`, 'ko-KR')) {
    return '올바르지 않은 형식입니다.';
  }

  return true;
}
